import React from 'react';
import { IS_TEST_ENVIRONMENT, TEST_ENVIRONMENT_LABEL } from '../../config/environment';
import './EnvironmentBanner.css';

const EnvironmentBanner: React.FC = () => {
  if (!IS_TEST_ENVIRONMENT) return null;

  return (
    <div className="environment-banner" role="status">
      ENTORNO DE {TEST_ENVIRONMENT_LABEL} — los datos no son reales
    </div>
  );
};

export default EnvironmentBanner;
